<template lang="pug">
.card.card-question(:class="qd_index % 2 === 0 ? 'even' : 'odd'")
  .card-content.card-content-question
    .opacity(v-if="review")
    .sequence câu hỏi 
      span.qindex(v-if="type_question === 2") {{qd_index}}
      i.material-icons.ic-delete(@click='deleteQuestionDetail(qd_index)' v-if="type_question === 2") delete
    .row.group-options
      .col-md-10.shuffle
        .col-md-5.title Dạng đáp án *
        .col-md-3.option 
          input(type="radio", :id="'typeAnswer1_' + qd_index", :name="'fmType' + qd_index" :checked="dataQD.type === 1" @click="onChangeType(1)")
          label(:for="'typeAnswer1_' + qd_index") Chọn đáp án đúng
        .col-md-3.option
          input(type="radio", :id="'typeAnswer2_' + qd_index", :name="'fmType' + qd_index" :checked="dataQD.type === 2" @click="onChangeType(2)")
          label(:for="'typeAnswer2_' + qd_index") Nhập câu trả lời
      .col-md-10.shuffle(v-if="dataQD.type === 1")
        .col-md-5.title Trộn đáp án trong các lần hiển thị khác nhau *
        .col-md-3.option
          input(type="radio", :id="'shuffle1_' + qd_index" :name="'shuffle' + qd_index" :checked="dataQD.shuffle" @click='onChangeShuffle(true)')
          label(:for="'shuffle1_' + qd_index") Có
        .col-md-3.option
          input(type="radio", :id="'shuffle2_' + qd_index", :name="'shuffle' + qd_index" :checked="!dataQD.shuffle" @click='onChangeShuffle(false)')
          label(:for="'shuffle2_' + qd_index") Không
      .clearfix
    .row.row-content
      .col-md-6.content-question-detail(v-if="type_question === 2")
        .form-group
          label.control-label Nội dung câu hỏi *
          froala(:tag="'textarea'" :config="config" v-model="dataQD.content" v-on:input="changeContentQD($event)")
      div(:class="type_question === 2 ? 'col-md-6 content-explain' : 'col-md-12 content-explain'" 
        :style="type_question === 1 ? 'padding-left: 15px; padding-right: 15px;' : ''")
        .form-group
          label.control-label Giải thích đáp án *
          froala(:tag="'textarea'" :config="config" v-model="dataQD.explain" v-on:input="changeExplain($event)")
      .clearfix
    .row.row-point
      .col-md-6.correct-question
        .form-group
          label.control-label Điểm cộng khi trả lời đúng *
          input.form-control(:id="'plus' + qd_index" type='number', required, value='0' min='0' v-model="dataQD.point" @change="changePoint(dataQD.point, true)")
      .col-md-6.wrong-question
        .form-group
          label.control-label Điểm trừ khi trả lời sai *
          input.form-control(:id="'minus' + qd_index" type='number', required, value='0', min='0' v-model="dataQD.subpoint" @change="changePoint(dataQD.subpoint, false)")
      .clearfix

    .col-md-12.theory-related
      .row-theory
        .col-md-6.col-md-theory
          .form-group
            label.control-label Lý thuyết liên quan *
            select.form-control(:id="'lesson_id' + qd_index" name="lesson_id" @change="onChangeLessonRelated" required)
              option(disabled value="0" selected) Chọn lý thuyết
              option(v-for='o in dataQD.lessonRemaining' :value='o.id' :data-content="o.content") {{o.name}}
      .div-lines
        .col-md-12.theory-lines(v-if="o" v-for="(o, iLesson) in dataQD.lessonRelated")
          .box-item-line
            .header
              .title 
                span {{o.name}}
              .ic_handle
                i.material-icons(@click='editTheory(o)') edit
                i.material-icons(@click='deleteTheory(iLesson)') delete
            .content(v-text="stripedHtml(o.content)")
      .clearfix
    .row.row-answer
      .col-md-12(v-if="dataQD.answers.length > 0")
        span Đáp án *
      .col-md-12.col-md-answer(v-for="(o, iAnswer) in dataQD.answers")
        answer(
          :qd_index='qd_index' 
          :value="String.fromCharCode(value + iAnswer)" 
          :iAnswer="iAnswer" 
          :id="o.count" 
          :isChecked="o.checked"
          :type="dataQD.type"
          :content="o.content"
          @onCheckedAnswer="updateCheckbox"
          @onDeleteAnswer="deleteAnswer"
          :key="force"
        )
        .clearfix
      .col-md-12.col-add-answer(v-if="dataQD.type === 1")
        span.add-answer(@click="addAnswer") + Thêm đáp án
</template>

<script>
// import gql from 'graphql-tag'
// import graphql from '../../Model/graphql'
import answer from '../Answer'
import jQuery from 'jquery'
export default {
  components: {
    jQuery,
    answer
  },
  props: {
    // id: Number,
    qd_index: Number,
    objQd: Object,
    type_question: Number,
    not_delete: Boolean,
    review: Boolean
  },
  data() {
    return {
      config: {
        fullPage: true,
        placeholderText: 'Nhập ...',
        charCounterCount: true,
        key: 'jUA1yD5B4D1C1F2D1pZGCTRSAPJWTLPLZHTQQb1JGZxE2F2G2B1B10B2A3E6D1G2==',
        iframe: true,
        immediateVueModelUpdate: true,
        charCounterMax: 14000,
        events: {}
      },
      answers: [],
      count: 0,
      value: 65,
      dataQD: {
        id: this.objQd.id,
        type: this.objQd.type, // 1.selection 2.text
        shuffle: this.objQd.shuffle,
        content: this.objQd.content,
        explain: this.objQd.explain,
        point: this.objQd.point,
        subpoint: this.objQd.subpoint,
        // lessons: [...this.objQd.lessons],
        lessonRelated: [...this.objQd.lessonRelated],
        lessonRemaining: [...this.objQd.lessonRemaining],
        answers: [...this.objQd.answers]
      },
      force: 0
    }
  },
  methods: {
    forceUpdate() {
      this.force++
    },
    deleteAnswer(data) {
      // Xoa dap an
      this.dataQD.answers.splice(data.iAnswer, 1)
      this.$emit('dataQuestionDetail', this.dataQD)
      this.forceUpdate()
    },
    updateCheckbox(data) {
      // Cap nhat dap an
      for (let a = 0; a < this.dataQD.answers.length; a++) {
        if (this.dataQD.answers[a].count === data.id) {
          this.dataQD.answers[a].checked = data.checked
          this.dataQD.answers[a].content = data.content
          this.dataQD.answers[a].value = data.value
        }
      }
      this.$emit('dataQuestionDetail', this.dataQD)
    },
    addAnswer() {
      // Them dap an
      if (this.dataQD.answers[this.dataQD.answers.length - 1] !== undefined) {
        this.count = this.dataQD.answers[this.dataQD.answers.length - 1].count + 1
      }
      var data = {
        count: this.count++,
        checked: false,
        content: ''
      }
      // this.answers.push(data)
      this.dataQD.answers.push(data)
      this.$emit('dataQuestionDetail', this.dataQD)
    },
    deleteQuestionDetail(iQuestion) {
      // Xoa cau hoi nho
      this.$emit('onItemDelete', iQuestion - 1)
    },
    deleteTheory(index) {
      // Xoa ly thuyet
      this.dataQD.lessonRemaining.push(this.dataQD.lessonRelated[index])
      this.dataQD.lessonRelated.splice(index, 1)
      this.$emit('dataQuestionDetail', this.dataQD)
    },
    editTheory(item) {
      // Chinh sua ly thuyet
      this.$emit('onEditTheory', item)
    },
    onChangeLessonRelated(e) {
      // Thay doi ly thuyet
      if (this.dataQD.lessonRelated.length > 9) {
        this.showNotification('Lý thuyết liên quan đã đủ 10', 'warning', 'top', 'right', 2000)
        jQuery('#lesson_id' + this.qd_index).val(0)
      } else {
        let obj = {'name': e.target.options[e.target.options.selectedIndex].innerText, 'id': e.target.value, 'content': e.target.options[e.target.options.selectedIndex].dataset.content}
        this.dataQD.lessonRelated.push(obj)
        this.dataQD.lessonRemaining.splice(this.dataQD.lessonRemaining.findIndex(({id}) => id === parseInt(e.target.value)), 1)
        jQuery('#lesson_id' + this.qd_index).val(0)
        this.$emit('dataQuestionDetail', this.dataQD)
      }
    },
    stripedHtml(htmlString) {
      var cont = document.createElement('span')
      cont.innerHTML = htmlString
      return cont.innerText
    },
    onChangeType(type) {
      // Đổi dạng đáp án
      // clear data đáp án hiện tại và tạo đáp án mới
      this.dataQD.type = type
      this.dataQD.answers = []
      this.forceUpdate()
      this.addAnswer()
      // this.$emit('dataQuestionDetail', this.dataQD)
    },
    onChangeShuffle(option) {
      // Có trộn đáp án ko ?
      this.dataQD.shuffle = option
      this.$emit('dataQuestionDetail', this.dataQD)
    },
    changeExplain(explain) {
      this.dataQD.explain = explain
      this.$emit('dataQuestionDetail', this.dataQD)
    },
    changeContentQD(text) {
      this.dataQD.content = text
      this.$emit('dataQuestionDetail', this.dataQD)
    },
    changePoint(point, type) {
      if (type) {
        this.dataQD.point = point
        this.$emit('dataQuestionDetail', this.dataQD)
      } else {
        this.dataQD.subpoint = point
        this.$emit('dataQuestionDetail', this.dataQD)
      }
    }
  },
  created() {
    if (this.not_delete) this.addAnswer()
  }
}
</script>

<style lang="scss" scoped>
.card-question {
  border-radius: 10px;
  margin-top: 0px;
  margin-bottom: 20px;
  border: 1px solid #FFD311;
  &.odd {background: #FBF4D2;}
  &.even {background: #FEFBF1;}
  background: #FBF4D2;
  border: 1px solid #FFD311;
  .card-content-question {
    .opacity {
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      opacity: 0.5;
      background: transparent;
      z-index: 100;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      cursor: no-drop;
    }
    .sequence {
      font-size: 15px; 
      text-transform: uppercase; 
      color: #9F6A28; 
      font-weight: bold;
      margin-bottom: 20px;
      .qindex {color: #9F6A28;}
      .ic-delete {float: right; color:#9F6A28; cursor: pointer;}
    }
    .group-options {
      .shuffle {
        margin-bottom: 20px;
        .title {padding-left: 0; font-size: 13px; font-weight: bold;}
        .option [type="radio"]:checked,.option [type="radio"]:not(:checked) { position: absolute; left: -9999px;}
        .option [type="radio"]:checked + label,
        .option [type="radio"]:not(:checked) + label{position: relative;padding-left: 28px;cursor: pointer;line-height: 20px;display: inline-block;color: #666;}
        .option [type="radio"]:checked + label:before,
        .option [type="radio"]:not(:checked) + label:before {content: ''; position: absolute;left: 0;top: 0;width: 18px;height: 18px;border: 1px solid #23180A;border-radius: 100%;background: #fff;}
        .option [type="radio"]:checked + label:after,
        .option [type="radio"]:not(:checked) + label:after {content: '';width: 10px; height: 10px; background: #9F6A28; position: absolute;top: 4px; left: 4px;border-radius: 100%; -webkit-transition: all 0.2s ease;transition: all 0.2s ease;}
        .option [type="radio"]:not(:checked) + label:after {opacity: 0; -webkit-transform: scale(0);transform: scale(0);}
        .option [type="radio"]:checked + label:after {opacity: 1; -webkit-transform: scale(1);transform: scale(1);}
      }
    }
    .row-content {
      margin-bottom: 15px;
      .content-question-detail {
        padding-right: 7.5px;
        .form-group {
          label {color: black; font-weight: bold; font-family: 'adobe-clean' sans-serif;}
          margin-top: 0;
          input, select {background-color: white;}
        }
      }
      .content-explain {
        padding-left: 7.5px;
        .form-group {
          label {color: black; font-weight: bold; font-family: 'adobe-clean' sans-serif;}
          margin-top: 0;
          input, select {background-color: white;}
        }
      }
    }
    .row-point {
      margin-bottom: 10px;
      .correct-question {
        padding-right: 7.5px;
        .form-group {
          label {color: black; font-weight: bold; font-family: 'adobe-clean' sans-serif;}
          margin-top: 0;
          input, select {background-color: white;}
        }
      }
      .wrong-question {
        padding-left: 7.5px;
        .form-group {
          label {color: black; font-weight: bold; font-family: 'adobe-clean' sans-serif;}
          margin-top: 0;
          input, select {background-color: white;}
        }
      }
    }
    .theory-related {
      background: #F8F8F8 0% 0% no-repeat padding-box;
      border-radius: 10px;
      padding-left: 0;
      padding-right: 0;
      margin-bottom: 24px;
      box-shadow: 0px 1px 2px #00000029;
      .row-theory {
        padding: 15px 0 0;
        .col-md-theory {
          padding-right: 0;
          .form-group {margin-top: 0;
            label {color: #9F6A28; font-size: 13px; font-weight: bold;}
          }
        }
      }
      .div-lines {
        // &:last-child {border: none !important; margin-bottom: 0;}
        .theory-lines {
          border-bottom: 1px solid #F2F2F2;
          margin-bottom: 15px;
          padding-bottom: 15px;
          padding-left: 0;
          margin-left: 15px;
          width: calc(100% - 15px);
          &:last-child {border: none !important; margin-bottom: 0;}
          .box-item-line {
            .header {
              display: flex;
              .title {font-weight: bold; font-size: 15px; color: #333333; display: inline-flex; width: calc(100% - 50px);
                span {text-overflow: ellipsis; white-space: nowrap; overflow: hidden; display: block;}
              }
              .ic_handle {display: inline-flex;
                .material-icons {cursor: pointer;}
              }
            }
            .content {color: #333333; font-size: 15px; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; padding-left: 0;}
          }
        }
      }
    }
    .row-answer {
      span {font-size: 13px; font-weight: bold;}
      .add-answer {
        font-family: 'adobe-clean' sans-serif;
        text-decoration: underline;
        color: blue;
        cursor: pointer;
        font-size: 13px;
        font-weight: normal !important;
      }
      .col-add-answer {margin-top: 8px;}
    }
  }
}
@media (max-width: 414px) {
  .card-question {
    .card-content-question {
      .row-content {
        .content-question-detail {padding-right: 15px;}
        .content-explain {padding-left: 15px;}
      }
      .group-options {
        .shuffle {
          .option {padding-left: 0;}
        }
      }
      .row-point {
        .correct-question {padding-right: 15px;}
        .wrong-question {padding-left: 15px;}
      }
      .theory-related {
        .row-theory {
          .col-md-theory {padding-right: 15px;}
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?bfd48596